define('presentation/welcome/viewModels/weekdayScheduleViewModel',[
    'constants/dayOfWeekEnumeration'
], function () {
    return function (openTime, closeTime) {
        const self = this;

        const _i18n = require('i18next');
        const _dayOfWeekEnumeration = require('constants/dayOfWeekEnumeration');

        let _disposables = [];

        const _openTime = openTime;
        const _closeTime = closeTime;

        const _convertToTime2400 = (time) => {
            if (!time) {
                return null;
            }

            time = time.trim().toLowerCase();
            const [timeStr, meridiem] = time.split(' ');
            const [hours, minutes] = timeStr.split(':');
            let hourNum = parseInt(hours, 10);

            if (meridiem === 'pm' && hourNum !== 12) {
                hourNum += 12;
            } else if (meridiem === 'am' && hourNum === 12) {
                hourNum = 0;
            }

            return `${hourNum.toString().padStart(2, '0')}:${minutes}`;
        };

        const _formatTimeValue = (isoTime) => {
            const [hours, minutes] = isoTime.split(':');
            const hourNum = parseInt(hours, 10);

            let meridiem = 'am';
            let hour = hourNum;

            if (hourNum >= 12) {
                meridiem = 'pm';
                hour = hourNum === 12 ? 12 : hourNum - 12;
            }
            if (hourNum === 0) {
                hour = 12;
            }

            return `${hour.toString().padStart(2, '0')}:${minutes} ${meridiem}`;
        };

        const _handleIsOpenChanged = (isOpen) => {
            if (!isOpen) {
                self.openTime(null);
                self.closeTime(null);
            }
        };

        self.dayOfWeek = ko.observable(0);
        self.openTime = ko.observable(null);
        self.closeTime = ko.observable(null);
        self.isOpen = ko.observable(false).toggleable();

        self.openTime2400 = ko.pureComputed(() => _convertToTime2400(self.openTime()));
        self.closeTime2400 = ko.pureComputed(() => _convertToTime2400(self.closeTime()));

        self.dayOfWeekName = ko.pureComputed(() =>  {
           switch (self.dayOfWeek()) {
               case _dayOfWeekEnumeration.sunday: {
                   return _i18n.t('onboardingAvailability:sunday');
               }
               case _dayOfWeekEnumeration.monday: {
                   return _i18n.t('onboardingAvailability:monday');
               }
               case _dayOfWeekEnumeration.tuesday: {
                   return _i18n.t('onboardingAvailability:tuesday');
               }
               case _dayOfWeekEnumeration.wednesday: {
                   return _i18n.t('onboardingAvailability:wednesday');
               }
               case _dayOfWeekEnumeration.thursday: {
                   return _i18n.t('onboardingAvailability:thursday');
               }
               case _dayOfWeekEnumeration.friday: {
                   return _i18n.t('onboardingAvailability:friday');
               }
               case _dayOfWeekEnumeration.saturday: {
                   return _i18n.t('onboardingAvailability:saturday');
               }
               default: {
                   return '';
               }
           } 
        });

        self.detached = () => {
            _disposables.forEach(subscription => subscription.dispose());
            _disposables = [];
        };

        const _initialize = () => {
            if (_openTime) {
                self.openTime(_formatTimeValue(_openTime));
            }

            if (_closeTime) {
                self.closeTime(_formatTimeValue(_closeTime));
            }

            const isOpen = self.openTime() || self.closeTime();
            self.isOpen(isOpen);

            _disposables.push(self.isOpen.subscribe(_handleIsOpenChanged));
        };

        _initialize();
    };
});

